<aside class="sidebar position-fixed top-0 h-100 bottom-0 left-0">
  <div class="sidebar-top position-relative mb-10">
    <a href="javascript:void(0)" class="opener position-absolute d-flex justify-content-center align-items-center" (click)="sidebarToggle($event)">
      <span [ngClass]="sidebarOpen ? 'icon-arrow-left-plain' : 'icon-arrow-right-plain'" class="text-neutral-n8"></span
    ></a>
    <div class="logo-holder px-20 py-20 d-flex flex-wrap justify-content-between">
      <a [routerLink]="['/dashboard']" class="logo">
        <img src="img/logo.png" alt="TELQ" />
      </a>
      <div class="top-icon-holder">
        <a [routerLink]="['/status']" class="d-inline" [tooltip]="'Show TelQ status page'">
          <span
            class="icon-status-1 icon"
            [ngClass]="{
              warning: ['major', 'minor', 'maintenance'].indexOf(currentStatus?.indicator) !== -1,
              error: currentStatus?.indicator === 'critical',
            }"></span>
        </a>

        <a
          #releaseNotesTrigger
          class="d-inline ms-10 me-10 cp text-primary-p3"
          [href]="releaseNotes.publicPageUrl"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Show the latest product updates"
          [tooltip]="'Show the latest notifications'">
          <span class="far fa-bell icon" aria-hidden="true"></span>
        </a>
      </div>
    </div>
  </div>

  <div #sidebarMenuMain class="sidebar-menu" id="sidebar-menu-main">
    <div class="sidebar-menu-holder">
      <div class="sidebar-menu-items px-10">
        <a [routerLink]="['/dashboard']" class="ps-15 pe-20 py-10 d-flex align-items-center"
          ><span class="sidebar-icon"><span class="icon-dashboard"></span></span><span class="link-name">Dashboard</span>
        </a>
      </div>
      <div class="tooltip-wrap">
        <a [routerLink]="['/dashboard']" class="tooltip-sm">Dashboard</a>
      </div>
    </div>

    <div class="sidebar-menu-holder">
      <div class="sidebar-menu-items px-10">
        <a [routerLink]="['/live-testing']" class="ps-15 pe-20 py-10 d-flex align-items-center"
          ><span class="sidebar-icon"><span class="icon-live-Number-Testing"></span></span><span class="link-name">Live number testing</span>
        </a>
      </div>
      <div class="tooltip-wrap">
        <a [routerLink]="['/live-testing']" class="tooltip-sm">Live Number Testing</a>
      </div>
    </div>

    <div class="sidebar-menu-holder">
      <div class="sidebar-menu-items px-10">
        <a [routerLink]="['/manual-testing']" class="ps-15 pe-20 py-10 d-flex align-items-center"
          ><span class="sidebar-icon"><span class="icon-manual-testing"></span></span><span class="link-name">Manual testing</span>
        </a>
      </div>
      <div class="tooltip-wrap">
        <a [routerLink]="['/manual-testing']" class="tooltip-sm">Manual Testing</a>
      </div>
    </div>

    <div class="sidebar-menu-holder" (mouseenter)="onMouseEnter($event)" (mouseleave)="onMouseLeave($event)" *ngIf="isVoiceAvailableForUser">
      <div class="sidebar-menu-items px-10 has-side-dropdown" id="sidemenuCliTesting">
        <a
          href="javascript:void(0)"
          class="parent-link ps-15 pe-20 py-10 d-flex align-items-center"
          data-bs-toggle="collapse"
          data-bs-target="#collapseCliTesting"
          aria-expanded="false"
          aria-controls="sidemenuCliTesting"
          ><span class="sidebar-icon"><span class="icon-cli-testing ms-0_1"></span></span><span class="link-name">CLI testing</span>
        </a>
      </div>
      <div class="drop-wrap ps-35 pe-15">
        <ul id="collapseCliTesting" class="collapse sidebar-dropdown" aria-labelledby="sidemenuCliTesting" data-bs-parent="#sidebar-menu-main">
          <li><a [routerLink]="['/cli-testing']">Manual СLI testing</a></li>
          <li><a [routerLink]="['/sip/testing']">SIP СLI testing</a></li>
        </ul>
      </div>
    </div>

    <div class="sidebar-menu-holder" *ngIf="isMoAvailableForUser && !isMoAllowedNumbersAvailableForUser">
      <div class="sidebar-menu-items px-10">
        <a [routerLink]="['/mo-testing']" class="ps-15 pe-20 py-10 d-flex align-items-center"
          ><span class="sidebar-icon"> <span class="icon-mo-testing"></span> </span><span class="link-name">MO testing</span>
        </a>
      </div>
      <div class="tooltip-wrap">
        <a [routerLink]="['/mo-testing']" class="tooltip-sm">MO Testing</a>
      </div>
    </div>

    <div
      class="sidebar-menu-holder"
      (mouseenter)="onMouseEnter($event)"
      (mouseleave)="onMouseLeave($event)"
      *ngIf="isMoAvailableForUser && isMoAllowedNumbersAvailableForUser">
      <div class="sidebar-menu-items px-10 has-side-dropdown" id="sidemenuMoTesting">
        <a
          href="javascript:void(0)"
          class="parent-link ps-15 pe-20 py-10 d-flex align-items-center"
          data-bs-toggle="collapse"
          data-bs-target="#collapseMoTesting"
          aria-expanded="false"
          aria-controls="sidemenuMoTesting"
          ><span class="sidebar-icon"><span class="icon-mo-testing"></span></span><span class="link-name">MO testing</span>
        </a>
      </div>
      <div class="drop-wrap ps-35 pe-15">
        <ul id="collapseMoTesting" class="collapse sidebar-dropdown" aria-labelledby="sidemenuMoTesting" data-bs-parent="#sidebar-menu-main">
          <li><a [routerLink]="['/mo-testing']">Testing</a></li>
          <li><a [routerLink]="['/mo-testing/short-codes']">Short codes</a></li>
        </ul>
      </div>
    </div>

    <div class="sidebar-menu-holder" (mouseenter)="onMouseEnter($event)" (mouseleave)="onMouseLeave($event)">
      <div class="sidebar-menu-items px-10 has-side-dropdown" id="sidemenuanalytics">
        <a
          href="javascript:void(0)"
          class="parent-link ps-15 pe-20 py-10 d-flex align-items-center"
          data-bs-toggle="collapse"
          data-bs-target="#collapseAnalytics"
          aria-expanded="false"
          aria-controls="collapseAnalytics"
          ><span class="sidebar-icon"><span class="icon-analytics"></span></span><span class="link-name">Analytics</span>
        </a>
      </div>
      <div class="drop-wrap ps-35 pe-15">
        <ul id="collapseAnalytics" class="collapse sidebar-dropdown" aria-labelledby="sidemenuanalytics" data-bs-parent="#sidebar-menu-main">
          <li><a [routerLink]="['/analytics/global']">Global</a></li>
          <li><a [routerLink]="['/analytics/live-testing']">Live testing</a></li>
          <li><a [routerLink]="['/analytics/manual-testing']">Manual testing</a></li>
        </ul>
      </div>
    </div>

    <div class="sidebar-menu-holder" (mouseenter)="onMouseEnter($event)" (mouseleave)="onMouseLeave($event)">
      <div class="sidebar-menu-items px-10 has-side-dropdown" id="sidemenuscheduler">
        <a
          href="javascript:void(0)"
          class="parent-link ps-15 pe-20 py-10 d-flex align-items-center"
          data-bs-toggle="collapse"
          data-bs-target="#collapseScheduler"
          aria-expanded="false"
          aria-controls="collapseScheduler"
          ><span class="sidebar-icon"><span class="icon-scheduler"></span></span><span class="link-name">Scheduler</span>
        </a>
      </div>
      <div class="drop-wrap ps-35 pe-15">
        <ul id="collapseScheduler" class="collapse sidebar-dropdown" aria-labelledby="sidemenuscheduler" data-bs-parent="#sidebar-menu-main">
          <li><a [routerLink]="['/scheduler/tasks']">Schedules</a></li>
          <li><a [routerLink]="['/scheduler/reports']">Reports</a></li>
        </ul>
      </div>
    </div>

    <div class="sidebar-menu-holder" (mouseenter)="onMouseEnter($event)" (mouseleave)="onMouseLeave($event)">
      <div class="sidebar-menu-items px-10 has-side-dropdown" id="sidemenuintegrationsettings">
        <a
          href="javascript:void(0)"
          class="parent-link ps-15 pe-20 py-10 d-flex align-items-center"
          data-bs-toggle="collapse"
          data-bs-target="#collapseIntegrationSettings"
          aria-expanded="false"
          aria-controls="collapseIntegrationSettings"
          ><span class="sidebar-icon"><span class="icon-connections"></span></span><span class="link-name">Integration settings</span>
        </a>
      </div>
      <div class="drop-wrap ps-35 pe-15">
        <ul
          id="collapseIntegrationSettings"
          class="collapse sidebar-dropdown"
          aria-labelledby="sidemenuintegrationsettings"
          data-bs-parent="#sidebar-menu-main">
          <!-- <li><a [routerLink]="['/suppliers']">Suppliers</a></li> -->
          <li><a [routerLink]="['/sessions']">SMPP & Suppliers</a></li>
          <li *ngIf="user && user.enabled"><a [routerLink]="['/user/account/api']">API</a></li>
          <li *ngIf="user && user.enabled && isVoiceAvailableForUser"><a [routerLink]="['/sip/config']">SIP configuration</a></li>
          <li *ngIf="user && user.enabled"><a [routerLink]="['/user/account/callback-history']">Callback history</a></li>
        </ul>
      </div>
    </div>

    <div class="sidebar-menu-holder" (mouseenter)="onMouseEnter($event)" (mouseleave)="onMouseLeave($event)">
      <div class="sidebar-menu-items px-10 has-side-dropdown" id="sidemenutemplates">
        <a
          href="javascript:void(0)"
          class="parent-link ps-15 pe-20 py-10 d-flex align-items-center"
          data-bs-toggle="collapse"
          data-bs-target="#collapseTemplates"
          aria-expanded="false"
          aria-controls="collapseTemplates">
          <span class="sidebar-icon"><span class="icon-templates-1"></span></span><span class="link-name">Templates</span>
        </a>
      </div>
      <div class="drop-wrap ps-35 pe-15">
        <ul id="collapseTemplates" class="collapse sidebar-dropdown" aria-labelledby="sidemenutemplates" data-bs-parent="#sidebar-menu-main">
          <li><a [routerLink]="['/content-templates']">Content templates</a></li>
          <li><a [routerLink]="['/test-case-templates']">Test templates</a></li>
        </ul>
      </div>
    </div>

    <div *ngIf="is(['admin'])" class="sidebar-menu-holder" (mouseenter)="onMouseEnter($event)" (mouseleave)="onMouseLeave($event)">
      <div class="sidebar-menu-items px-10 has-side-dropdown" id="sidemenuadminsettings">
        <a
          href="javascript:void(0)"
          class="parent-link ps-15 pe-20 py-10 d-flex align-items-center"
          data-bs-toggle="collapse"
          data-bs-target="#collapseAdminSettings"
          aria-expanded="false"
          aria-controls="collapseAdminSettings">
          <span class="sidebar-icon"><span class="icon-admin-settings"></span></span><span class="link-name">Admin Settings</span>
        </a>
      </div>
      <div class="drop-wrap ps-35 pe-15">
        <ul id="collapseAdminSettings" class="collapse sidebar-dropdown" aria-labelledby="sidemenuadminsettings" data-bs-parent="#sidebar-menu-main">
          <li><a [routerLink]="['/net-info/countries']">Countries</a></li>
          <li><a [routerLink]="['/net-info/networks']">Networks</a></li>
          <li><a [routerLink]="['/stop-words']">Stop words</a></li>
          <li><a [routerLink]="['/settings']">Disable testing</a></li>
          <li><a [routerLink]="['/audit/logs/v2']">Logs</a></li>
        </ul>
      </div>
    </div>

    <div *ngIf="is(['admin'])" class="sidebar-menu-holder" (mouseenter)="onMouseEnter($event)" (mouseleave)="onMouseLeave($event)">
      <div class="sidebar-menu-items px-10 has-side-dropdown" id="sidemenumodems">
        <a
          href="javascript:void(0)"
          class="parent-link ps-15 pe-20 py-10 d-flex align-items-center"
          data-bs-toggle="collapse"
          data-bs-target="#collapseModems"
          aria-expanded="false"
          aria-controls="collapseAdminSettings">
          <span class="sidebar-icon"><span class="far fa-building"></span></span><span class="link-name">Modems</span>
        </a>
      </div>
      <div class="drop-wrap ps-35 pe-15">
        <ul id="collapseModems" class="collapse sidebar-dropdown" aria-labelledby="sidemenumodems" data-bs-parent="#sidebar-menu-main">
          <li><a [routerLink]="['/appscripts/numbers']">Numbers</a></li>
          <li><a [routerLink]="['/appscripts/payment-requests']">Payment Request</a></li>
          <li><a [routerLink]="['/appscripts/payment-methods']">Payment Methods</a></li>
          <li><a [routerLink]="['/appscripts/mt-sms']">MT SMS</a></li>
          <li><a [routerLink]="['/appscripts/mo-sms']">MO SMS</a></li>
          <li><a [routerLink]="['/appscripts/cli']">CLI</a></li>
          <li><a [routerLink]="['/appscripts/mt-tiers']">MT Tiers</a></li>
          <li><a [routerLink]="['/appscripts/settings']">Settings</a></li>
          <li><a [routerLink]="['/support/tickets']">Support</a></li>
        </ul>
      </div>
    </div>

    <div [hidden]="!is(['admin'])" class="sidebar-menu-holder" (mouseenter)="onMouseEnter($event)" (mouseleave)="onMouseLeave($event)">
      <div class="sidebar-menu-items px-10">
        <a [routerLink]="['/users']" class="parent-link ps-15 pe-20 py-10 d-flex align-items-center"
          ><span class="sidebar-icon"> <span class="fas fa-user-friends fs-4"></span> </span><span class="link-name">Users</span>
        </a>
      </div>
      <div class="tooltip-wrap">
        <a [routerLink]="['/users']" class="tooltip-sm">Users</a>
      </div>
    </div>

    <div [hidden]="!is(['admin'])" class="sidebar-menu-holder" (mouseenter)="onMouseEnter($event)" (mouseleave)="onMouseLeave($event)">
      <div class="sidebar-menu-items px-10 has-side-dropdown" id="sidemenuprices">
        <a
          href="javascript:void(0)"
          class="parent-link ps-15 pe-20 py-10 d-flex align-items-center"
          data-bs-toggle="collapse"
          data-bs-target="#collapsePrices"
          aria-expanded="false"
          aria-controls="collapsePrices">
          <span class="sidebar-icon"><span class="icon-price"></span></span><span class="link-name">Billing</span>
        </a>
      </div>
      <div class="drop-wrap ps-35 pe-15">
        <ul id="collapsePrices" class="collapse sidebar-dropdown" aria-labelledby="sidemenuprices" data-bs-parent="#sidebar-menu-main">
          <li><a [routerLink]="['/pricing-general']">General</a></li>
          <li><a [routerLink]="['/pricing-special']">Special</a></li>
        </ul>
      </div>
    </div>

    <div *ngIf="is(['mainaccount', 'deputy'], true) && user.paymentType === 'POSTPAID' && isBillingAvailableForUser" class="sidebar-menu-holder">
      <div class="sidebar-menu-items px-10">
        <a [routerLink]="['/billing/postpaid']" class="parent-link ps-15 pe-20 py-10 d-flex align-items-center"
          ><span class="sidebar-icon"> <span class="icon-price"></span> </span><span class="link-name">Billing</span>
        </a>
      </div>
      <div class="tooltip-wrap">
        <a [routerLink]="['/billing/postpaid']" class="tooltip-sm">Billing</a>
      </div>
    </div>

    <div *ngIf="is(['mainaccount', 'deputy'], true) && user.paymentType === 'PREPAID' && isBillingAvailableForUser" class="sidebar-menu-holder">
      <div class="sidebar-menu-items px-10">
        <a [routerLink]="['/billing/prepaid']" class="ps-15 pe-20 py-10 d-flex align-items-center"
          ><span class="sidebar-icon"> <span class="icon-price"></span> </span><span class="link-name">Billing</span>
        </a>
      </div>
      <div class="tooltip-wrap">
        <a [routerLink]="['/billing/prepaid']" class="tooltip-sm">Billing</a>
      </div>
    </div>

    <div *ngIf="is(['mainaccount', 'deputy'])" class="sidebar-menu-holder">
      <div class="sidebar-menu-items px-10">
        <a [routerLink]="['/invoices']" class="ps-15 pe-20 py-10 d-flex align-items-center"
          ><span class="sidebar-icon"> <span class="icon-payments"></span> </span><span class="link-name">Invoices</span>
        </a>
      </div>
      <div class="tooltip-wrap">
        <a [routerLink]="['/invoices']" class="tooltip-sm">Invoices</a>
      </div>
    </div>

    <div *ngIf="is(['admin'])" class="sidebar-menu-holder" (mouseenter)="onMouseEnter($event)" (mouseleave)="onMouseLeave($event)">
      <div class="sidebar-menu-items px-10 has-side-dropdown" id="sidemenuinvoices">
        <a
          href="javascript:void(0)"
          class="parent-link ps-15 pe-20 py-10 d-flex align-items-center"
          data-bs-toggle="collapse"
          data-bs-target="#collapseInvoices"
          aria-expanded="false"
          aria-controls="collapseInvoices"
          ><span class="sidebar-icon"><span class="icon-payments"></span></span><span class="link-name">Invoices</span>
        </a>
      </div>
      <div class="drop-wrap ps-35 pe-15">
        <ul id="collapseInvoices" class="collapse sidebar-dropdown" aria-labelledby="sidemenuinvoices" data-bs-parent="#sidebar-menu-main">
          <li><a [routerLink]="['/invoices']">Invoices</a></li>
          <li><a [routerLink]="['/invoices/matching']">Payment Matching</a></li>
        </ul>
      </div>
    </div>

    <div class="sidebar-menu-holder" (mouseenter)="onMouseEnter($event)" (mouseleave)="onMouseLeave($event)">
      <div class="sidebar-menu-items px-10 has-side-dropdown" id="sidemenuother">
        <a
          href="javascript:void(0)"
          class="parent-link ps-15 pe-20 py-10 d-flex align-items-center"
          data-bs-toggle="collapse"
          data-bs-target="#collapseOther"
          aria-expanded="false"
          aria-controls="collapseOther"
          ><span class="sidebar-icon"><span class="icon-setting-2"></span></span><span class="link-name">Other</span>
        </a>
      </div>
      <div class="drop-wrap ps-35 pe-15">
        <ul id="collapseOther" class="collapse sidebar-dropdown" aria-labelledby="sidemenuother" data-bs-parent="#sidebar-menu-main">
          <li><a [routerLink]="['/other/coverage']">Coverage</a></li>
          <li><a [routerLink]="['/other/reported-numbers']">Reported Numbers</a></li>
        </ul>
      </div>
    </div>

    <div class="sidebar-menu-holder">
      <div class="sidebar-menu-items px-10">
        <a [routerLink]="['/news']" class="ps-15 pe-20 py-10 d-flex align-items-center"
          ><span class="sidebar-icon"><span class="far fa-newspaper"></span></span><span class="link-name">News</span>
        </a>
      </div>
      <div class="tooltip-wrap">
        <a [routerLink]="['/news']" class="tooltip-sm">News</a>
      </div>
    </div>
  </div>

  <div class="sidebar-bottom position-absolute">
    <app-balance-widget></app-balance-widget>
    <app-profile></app-profile>
  </div>
</aside>
